<template>
<div>
    <div class="position-relative">
        <!-- shape Hero -->
        <section class="section-shaped my-0">
            <div class="shape shape-style-1 shape-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-6">
                            <h1 class="display-3 text-white">
                                Working remotely,
                                <br>your team next to you.
                                <br>
                                <br>
                                <span>
                    Full team presence,
                    <br>work side-by-side,
                    <br>fully automated.
                  </span>
                            </h1>
                            <div class="btn-wrapper" style="margin-top: 20px">

                                <br>
                                <div class="row">
                                    <div class="col-lg-4 mt-5">
                                        <card gradient="secondary" style="text-align:center">
                                            <h6>OSX</h6>
                                            <div class="mb-3">
                                                <img v-lazy="'img/icons/common/apple.svg'" style="height:50px;">
                        </div>
                                                <base-button tag="a" href="https://teamstatusapp.firebaseapp.com/TeamStatus.zip" type="default" block>Install</base-button>
                                        </card>
                                    </div>
                                    <div class="col-lg-4 mt-5">
                                        <card gradient="secondary" style="text-align:center">
                                            <h6>Chrome</h6>
                                            <div class="mb-3">
                                                <img v-lazy="'img/icons/common/chrome.svg'" style="height:50px;">
                        </div>
                                                <base-button tag="a" target="_blank" href="https://chrome.google.com/webstore/detail/teamstatus/impfakphdplejlofdcpckohbafekjdam" type="default" block>Install</base-button>
                                        </card>
                                    </div>
                                    <div class="col-lg-4 mt-5">
                                        <card gradient="secondary" style="text-align:center">
                                            <h6>Windows 10</h6>
                                            <div class="mb-3">
                                                <img v-lazy="'img/icons/common/windows.svg'" style="height:50px;">
                        </div>
                                                <base-button tag="a" href="https://teamstatusapp.firebaseapp.com/publish.htm" type="default" block>Install</base-button>
                                        </card>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1"></div>
                        <div class="col-lg-5">
                            <img
                  v-lazy="'img/theme/teamview.png'"
                  class="card-img-top"
                  style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);"
                >
              </div>
                        </div>
                    </div>
                </div>
        </section>
        <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <h6 class="text-primary text-uppercase">Your status. Fully automated.</h6>
                                <p class="description mt-3">Boost your real team presence with automated status updates .</p>
                                <div>
                                    <img v-lazy="'img/theme/undraw_post_online.svg'" class="card-img-top">
                  </div>
                            </card>
                        </div>
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <h6 class="text-primary text-uppercase">Isolation?</h6>
                                <p class="description mt-3">Overcoming Isolation for Remote Teams to make your team feel connected.</p>
                                <div>
                                    <img v-lazy="'img/theme/undraw_status_update.svg'" class="card-img-top">
                                    <img
                      v-lazy="'img/theme/undraw_online_friends.svg'"
                      class="card-img-top"
                      style="margin-top:38px"
                    >
                  </div>
                            </card>
                        </div>
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <h6 class="text-primary text-uppercase">Timezones?</h6>
                                <p class="description mt-3">
                                    No worries.
                                    Watch all the local times of your team in one window.
                                </p>
                                <div>
                                    <img
                      v-lazy="'img/theme/undraw_world.svg'"
                      class="card-img-top"
                      style="margin-top:40px;padding-bottom:30px"
                    >
                  </div>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6">
                    <img src="img/theme/statusupdate.svg" class="img-fluid">
          </div>
                    <div class="col-md-6">
                        <h3 class="text-primary text-uppercase">Automate your status</h3>
                        <p>Set your own status message whenever the selected application becomes active. Your privacy is respected and only your status messages will be transmitted.</p>
                    </div>
                </div>
                <div class="row row-grid align-items-center">
                    <div class="col-md-9">
                        <h3 class="text-primary text-uppercase">Selfie photos</h3>
                        <p>TeamStatus lets you see the faces of the people you work with throughout the day, giving you real presence, improving company culture and team building!</p>
                    </div>
                    <div class="col-md-3">
                        <img src="img/theme/team_snapshots.svg" class="img-fluid">
          </div>
                    </div>
                    <div class="row row-grid align-items-center">
                        <div class="col-md-3">
                            <img src="img/theme/undraw_real-time_sync.svg" class="img-fluid">
          </div>
                            <div class="col-md-9">
                                <h3 class="text-primary text-uppercase">Sync your status with Slack</h3>
                                <p>TeamStatus will sync your status to your Slack status. Also it works vice-versa, status changes from Slack appear in TeamStatus.</p>
                            </div>
                        </div>
                        <div class="row row-grid align-items-center">
                            <div class="col-md-9">
                                <h3 class="text-primary text-uppercase">Google Calendar integration</h3>
                                <p>Whenever an event starts in Google Calendar, TeamStatus will update your status. That way, your team will know your scheulde with no extra effort on your part.</p>
                            </div>
                            <div class="col-md-3">
                                <img src="img/theme/undraw_calendar.svg" class="img-fluid">
          </div>
                            </div>
                        </div>
    </section>
    <section class="section bg-secondary">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6">
                    <div class="card bg-default shadow border-0">
                        <img v-lazy="'img/theme/14039.jpg'" class="card-img-top">
                        <blockquote class="card-blockquote">
                            <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                  <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                </svg>
                            <h4 class="display-3 font-weight-bold text-white">Team building</h4>
                            <p class="lead text-italic text-white">Remote work is sometimes tough. It's hard to stay in touch. TeamStatus improves your company culture and helps with team building!</p>
                        </blockquote>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="pl-md-5">
                        <h3>Team presence is important</h3>
                        <p class="lead">
                            We are helping team members who work remotely or in a distributed team so they feel more a part of the office/team, and visa versa wherever they are located.
                            Rather than getting frustrated if no one answered the phone or responded on Slack,
                            we can easily see from a quick glance whether someone is available. It helps us create a ‘virtual office’,
                            satisfies a social need and improves the quality of communication and the atmosphere among the team.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="section section section-shaped my-0 overflow-hidden">
        <div class="shape shape-style-1 bg-gradient-warning shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0">
            <div class="row row-grid align-items-center">
                <div class="col-md-6 order-lg-2 ml-lg-auto">
                    <div class="position-relative pl-md-5">
                        <img src="img/ill/ill-2.svg" class="img-center img-fluid">
            </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Bring Your Team Closer</h4>
                                <p class="text-white">Empower you and your teammates to bring work and life into harmony—to be able to stay connected and collaborative no matter where in the world you’re located.</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Increase Productivity</h5>
                                    <p>No reason to ask “are you available?” Make decisions in the moment. Communicate & Get work done efficiently. TeamStatus enables instant collaboration.</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-world" gradient="warning" color="white" shadow rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Overcome Distance</h5>
                                    <p>Hire the best people for your team – regardless of their location. Overcome barriers of physical distance by providing real team presence. The TeamStatus workspace magically enables innovation, increases engagement and builds trust amongst team members.</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
    </section>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-12 align-items-center text-center">
                    <h3 class="text-primary text-uppercase">Birds-eye view of your team</h3>
                    <p>See your team interaction happening in real time.</p>
                    <img src="img/theme/Group.png" class="img-fluid" style="max-width:600px">
          </div>
                </div>
            </div>
    </section>
    <section class="section section-lg pt-0" id="install">
        <div class="container">
            <card gradient="warning" no-body shadow-size="lg" class="border-0">
                <div class="p-5">
                    <div class="row align-items-center">
                        <div class="col-lg-8">
                            <h3 class="text-white">Get TeamStatus</h3>
                            <p class="lead text-white mt-3">We recommend to install the desktop client for full feature support. TeamStatus can also run in any browser.</p>
                        </div>
                    </div>
                </div>
            </card>

            <div class="row">
                <div class="col-lg-4 mt-5">
                    <card gradient="secondary" style="text-align:center">
                        <h5>OSX</h5>
                        <div class="mb-3">
                            <img v-lazy="'img/icons/common/apple.svg'" style="height:70px;">
              </div>
                            <base-button tag="a" href="https://teamstatusapp.firebaseapp.com/TeamStatus.zip" type="default" block size="lg">Download</base-button>
                    </card>
                </div>
                <div class="col-lg-4 mt-5">
                    <card gradient="secondary" style="text-align:center">
                        <h5>Chrome</h5>
                        <div class="mb-3">
                            <img v-lazy="'img/icons/common/chrome.svg'" style="height:70px;">
              </div>
                            <base-button tag="a" target="_blank" href="https://chrome.google.com/webstore/detail/teamstatus/impfakphdplejlofdcpckohbafekjdam" type="default" block size="lg">Install</base-button>
                    </card>
                </div>
                <div class="col-lg-4 mt-5">
                    <card gradient="secondary" style="text-align:center">
                        <h5>Windows 10</h5>
                        <div class="mb-3">
                            <img v-lazy="'img/icons/common/windows.svg'" style="height:70px;">
              </div>
                            <base-button tag="a" href="https://teamstatusapp.firebaseapp.com/publish.htm" type="default" block size="lg">Download</base-button>
                    </card>
                </div>
            </div>
        </div>
    </section>
    <section class="section section-shaped my-0 overflow-hidden" style="display:none">
        <div class="shape shape-style-3 bg-gradient-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg pb-300">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-white">Contact us</h2>
                </div>
            </div>
        </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us" style="display:none">
        <div class="container">
            <div class="row justify-content-center mt--300">
                <div class="col-lg-8">
                    <card gradient="secondary" shadow body-classes="p-lg-5">
                        <h4 class="mb-1">Want to work with us?</h4>
                        <p class="mt-0">Your project is very important to us.</p>
                        <base-input class="mt-5" alternative placeholder="Your name" addon-left-icon="ni ni-user-run"></base-input>
                        <base-input alternative placeholder="Email address" addon-left-icon="ni ni-email-83"></base-input>
                        <base-input class="mb-4">
                            <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                ></textarea>
                        </base-input>
                        <base-button type="default" round block size="lg">Send Message</base-button>
                    </card>
                </div>
            </div>
        </div>
    </section>
    <section class="section section-lg" style="">
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-12 text-center">
                    <h2 class="display-3">
                        Pricing
                    </h2>
                    <div class="row mt-5">
                        <div class="col-lg-5">
                            <div class="card shadow-lg--hover mt-5 shadow bg-secondary">
                                <div class="card-body">
                                    <h3 class="text-primary">FREE PLAN</h3>
                                    <p class="lead">
                                        Enjoy all features for free during beta
                                        <br/>After that, up to 3 team members
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2">
                        </div>
                        <div class="col-lg-5">
                            <div class="card shadow-lg--hover mt-5 shadow bg-secondary">
                                <div class="card-body">
                                    <h3 class="text-primary">PRO PLAN</h3>
                                    <p class="lead">
                                        Coming with stable 1.0 release <br/><span class="paddle-gross font-weight-bold" data-product="558947">€4</span> per user per month
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
    <section class="section section-lg" style="">
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-12 text-center">
                    <h2 class="display-3">
                        Privacy and Security in TeamStatus
                    </h2>
                </div>
                <div class="row mt-5">
                  Our infrastructure successfully completed the ISO 27001, ISO 27017, 27018 and SOC 1, SOC 2, and SOC 3 evaluation process.
                  <br/>TeamStatus encrypts data in transit using HTTPS and logically isolates customer data. 
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: "home",
    components: {}
};
</script>
